var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-puzzle",class:{ 'c-puzzle--correct': _vm.correct }},_vm._l((_vm.order),function(pieceIndex,index){return _c('div',{staticClass:"c-puzzle__piece",class:{
      'c-puzzle__piece--checked':
        _vm.checkedFirstIndex === index || _vm.checkedSecondIndex === index
    },style:({
      backgroundImage: ("url(" + (_vm.pieces[pieceIndex - 1]) + ")")
    }),on:{"click":function($event){return _vm.togglePiece(index)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }